module.exports = __webpack_public_path__ + "img/ru.c60efea9.svg";